const ITEMS = [
  "Believe in yourself",
  "You Got This!",
  "Lil Momma & Man-Man",
  "Author Corella Berry-Moten",
  "You hold the pen",
  "Captain #76",
  "Write your own story",
  "A Spooky Halloween Adventure",
  "Spread kindness",
];

const Star = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="#FFD23F" aria-hidden="true">
    <path d="M12 1.5 L14.9 8.6 L22.5 9.2 L16.7 14.2 L18.4 21.8 L12 17.9 L5.6 21.8 L7.3 14.2 L1.5 9.2 L9.1 8.6 Z" />
  </svg>
);

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-banner"
      className="overflow-hidden border-y-2 border-ink bg-royal py-3.5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-8 pr-8">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-8 font-mono text-sm font-bold uppercase tracking-[0.25em] text-banana">
            {t}
            <Star />
          </span>
        ))}
      </div>
    </div>
  );
}
